import { LOG_OUT_USER, UPDATE_AUTHORIZED, VERIFY_TOKEN } from "./actionTypes";
import { clearTokens } from "../../utils/customStorage";


const updateAuthorized = (value) => ({
    type: UPDATE_AUTHORIZED,
    payload: value
});

const verifyToken = () => ({
    type: VERIFY_TOKEN,
    payload: null
});

const logoutUser = () => {
    clearTokens();
    return {
        type: LOG_OUT_USER,
        payload: true,
        errors: null
    };
}

export {
    updateAuthorized, verifyToken, logoutUser
};